import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ColumnDefinition } from '../../../model/column-definition';
import { ExpandedListViewItemDefinition } from '../../../model/expanded-list-view-item';
import ListViewColumn from '../../../model/list-view-column';
import { ExpandedListViewRow } from '../../../model/list-view-row';
import { ListViewColumnFactory } from '../../../service/factory/list-view-column-factory.service';
import { RowClickEvent } from '../list-view.base';

@Component({
    selector: 'app-expanded-list-view',
    templateUrl: './expanded-list-view.component.html',
    styleUrls: ['./expanded-list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExpandedListViewComponent<TSource = any> implements OnChanges, OnInit, OnDestroy {
  constructor(private _cf: ListViewColumnFactory) {}

  @Input() columnDefinitions: ColumnDefinition[];
  @Input() itemsSource: ExpandedListViewItemDefinition<TSource>[] = [];
  @Input() expandAllRows: boolean = false;
  @Input() preferencesKey: string;
  @Output() rowClick = new EventEmitter<RowClickEvent<TSource>>();
  @Output() captionClick = new EventEmitter<RowClickEvent<ExpandedListViewRow<TSource>>>();

  get captionIsLink() {
    return this.captionClick.observed;
  }

  columns: ListViewColumn[];
  rows: ExpandedListViewRow<TSource>[];

  ngOnInit() {
    this.columns = this.columnDefinitions ? this._cf.create(this.columnDefinitions) : [];
  }

  ngOnDestroy(): void {
    if (this.rows && Array.isArray(this.rows)) {
      for (let row of this.rows) {
        if (row.loadSubscription) row.loadSubscription.unsubscribe();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const itemsSourceChanged = !!changes['itemsSource'];
    const expandAllRowsChanged = !!changes['expandAllRows'];

    const itemsSource = this.itemsSource || [];
    const existingRows = this.rows || [];

    if (itemsSourceChanged) {
      this.rows = itemsSource.map(item => {
        const row = new ExpandedListViewRow(item.caption, item.dataContext, item.icon);
        row.columnDefinitions = item.columnDefinitions;
        row.items = item.itemsSource;
        row.dataLoader = item.dataLoader;
        return row;
      });
      this.toggleExpandedOnAllRows();
    } else if (expandAllRowsChanged && this.rows && this.rows.length > 0) {
      this.toggleExpandedOnAllRows();
    }
  }

  onClick(item: ExpandedListViewRow<TSource>) {
    item.expanded = !item.expanded;
  }

  onCaptionClicked(event: PointerEvent, item: ExpandedListViewRow<TSource>): void {
    this.captionClick.emit({ event, context: item });
  }

  onExpandedContentRowClicked(event: RowClickEvent): void {
    this.rowClick.emit(event);
  }

  toggleExpandedOnAllRows() {
    if (!this.rows || !this.rows.length) return;
    for (let row of this.rows) {
      row.expanded = this.expandAllRows;
    }
  }
}
